{
  "zh-CN": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      },
      "confirm": {
        "question": "确定?",
        "yes": "是",
        "no": "否"
      }
    }
  }
}
